import { HbrDivider } from '@harbor/elements-react-standalone';
import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { useFetchEscalationRequests } from '../../../hooks/escalation-request-hooks';
import { EscalationRequest } from '../../../types/approval-request';
import OpportunityEscalationListItem from './OpportunityEscalationListItem';

const OpportunityEscalationList: React.FC = () => {
  const { id: opportunityId } = useParams();

  const {
    data: escalations,
    isLoading: loadingEscalations,
  } = useFetchEscalationRequests(
    opportunityId,
    {},
    { enabled: !!opportunityId }
  );

  const displayEscalations = useMemo(() => {
    if (!escalations) return [];

    return escalations
      .filter((escalation) => escalation.status?.title !== 'Cancelled')
      .sort((a, b) => {
        const nameCompare = (a.product_name ?? a.product?.name ?? '').localeCompare(
          b.product_name ?? b.product?.name ?? '',
          undefined,
          { sensitivity: 'base' }
        );

        if (nameCompare !== 0) return nameCompare;

        const aLastUpdated = new Date(
          (a as EscalationRequest & { last_updated?: string }).last_updated ?? 0
        ).getTime();

        const bLastUpdated = new Date(
          (b as EscalationRequest & { last_updated?: string }).last_updated ?? 0
        ).getTime();

        return bLastUpdated - aLastUpdated;
      });
  }, [escalations]);

  return (
    <div>
      <h3>Escalations</h3>

      {loadingEscalations ? (
        <div className="italic">Loading escalations...</div>
      ) : !displayEscalations || displayEscalations.length === 0 ? (
        <div className="italic">No escalations yet. </div>
      ) : (
        displayEscalations.map((escalation) => (
          <OpportunityEscalationListItem
            key={escalation.id}
            escalationId={escalation.id}
            opportunityId={opportunityId}
          />
        ))
      )}

      <HbrDivider className="mt-4" />
    </div>
  );
};

export default OpportunityEscalationList;